module.exports = __webpack_public_path__ + "img/MarkerPopuo.0cf0abcf.png";